/*
 * @overview: 拦截 XMLHttpRequest，监听响应错误，判断是否处于升级中。
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 10:19:21
 */

import { getService, noticeApi, serviceApi } from "../api/http";
import { createNotification } from "../utils";

/**
 * 监听xhr, 重写了 XMLHttpRequest 的 send 方法
 * 添加事件监听器 load，触发对应的事件处理函数
 */
export function injectReminder() {
  let XMLHttpRequest = window.XMLHttpRequest;
  const oldOpen = XMLHttpRequest.prototype.open;
  // 重写open方法，添加拦截器功能
  XMLHttpRequest.prototype.open = function (method, url, async) {
    // 不拦截升级通知相关请求，防止死循环
    if (url.indexOf(noticeApi) === -1 && url.indexOf(serviceApi) === -1) {
      this.url = url;
    }
    return oldOpen.apply(this, arguments);
  };

  let oldSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (this.url) {
      let handler = () => (e) => {
        let status = this.status;
        // 服务器出错时,j进行升级中判定
        if (status !== 200 && status !== 204) {
          isUpgrading(this.url);
        }
      };
      this.addEventListener("load", handler(), false);
      this.addEventListener("error", handler("error"), false);
      this.addEventListener("abort", handler("abort"), false);
    }
    return oldSend.apply(this, arguments);
  };
}

/**
 * 升级中判定
 * @param {*} url 当前请求地址
 */
async function isUpgrading(url) {
  const { data } = await getService();
  if (!data) return;
  let match = false;
  let cur = {};
  for (let item of data) {
    if (url.includes(item.address)) {
      match = true;
      cur = item;
      break;
    }
  }
  if (!match) return;
  createNotification(
    "升级提醒",
    `当前项目正在升级中，预计在 ${cur.endTime} 完成升级。请稍后再试~`
  );
}
